import React from "react";

import { appConstants } from "../../config/app-constants";

type Props = {};

const TotalTDSHint: React.FC<Props> = (props: Props) => {
	return (
		<>
			<section className="text-center">
				<img
					src={`${appConstants.basePath}/assets/images/hints/tds-form16.png`}
					alt="Form16 TDS"
					className="img-fluid d-block mx-auto my-4"
				/>

				<h5 className="text-start my-4">Payslip income tax</h5>

				<img
					src={`${appConstants.basePath}/assets/images/hints/payslip-tds.png`}
					alt="PaySlip TDS"
					className="img-fluid d-block mx-auto my-4"
				/>
			</section>
		</>
	);
};

export default TotalTDSHint;
